/* __next_internal_client_entry_do_not_use__ ProductTileContextProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { ProductTileContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import React, { useMemo } from "react";
export var ProductTileContextProvider = function(param) {
    var brandToken = param.brandToken, brand = param.brand, children = param.children;
    var contextValue = useMemo(function() {
        return {
            recordAdImpression: true,
            brandToken: brandToken,
            brand: brand
        };
    }, [
        brand,
        brandToken
    ]);
    return /*#__PURE__*/ _jsx(ProductTileContext.Provider, {
        value: contextValue,
        children: children
    });
};
